<header class="Infy_Header">
  <div id="headerComp-header-DIV" class="containerPos">
    <a class="customMenuAnchorSize" (click)="home()" (keyup.enter)="home()" tabindex="0">
      <img class="customLogoSize responsive-logo" alt="logo" src="assets/images/vendor_images/Group 17520@2x.png" />
    </a>

    <div class="lineStyle"></div>

    <span class="text-style">Partner Hub</span>

    @if (!unAuthFlag) {
      <div class="selectStyle">
        <mat-select
          class="selectPadFont"
          panelClass="customPanel"
          [(value)]="companyHiringTypeId"
          (selectionChange)="getHeaderEntities(companyHiringTypeId)"
        >
          @for (entity of entities; track entity) {
            <mat-option [value]="entity.id">
              {{ entity.organization }}
            </mat-option>
          }
        </mat-select>
      </div>
    }

    @if (!unAuthFlag) {
      <ul id="headerComp-header-div2" class="float-right">
        <li>
          <span>
            @if (!condition) {
              <a [matMenuTriggerFor]="menu2" class="custom-button menuTriggerAnchorStyle" href="javascript:void(0)">
                <span>{{ userDetailsData?.vendorName | initials }}</span>
              </a>
            }
            <mat-menu #menu2="matMenu">
              <button class="marB8" mat-menu-item>
                <span class="userNameClass">Hello, {{ userDetailsData?.vendorName }} !</span>
              </button>
              @if (!unAuthFlag) {
                <div>
                  <mat-form-field
                    (click)="$event.stopPropagation()"
                    (keyup.enter)="$event.stopPropagation()"
                    tabindex="0"
                    style="margin-left: 10px; margin-right: 10px"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>Switch role</mat-label>
                    <mat-select class="limitCss" [(value)]="selectedRole" (selectionChange)="closeMenu()">
                      @for (role of roles; track role) {
                        <mat-option [value]="role.role">
                          {{ role.displayName }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              @if ((!unAuthFlag && !infyUser) || !infyUser) {
                <button mat-menu-item>
                  <a
                    class="menuButtonDecor"
                    href="javascript:void(0)"
                    (click)="userProfileDetails()"
                    (keyup.enter)="userProfileDetails()"
                    tabindex="0"
                    ><span>Your Profile</span>
                  </a>
                </button>
              }
              @if ((!unAuthFlag && !infyUser) || !infyUser) {
                <button
                  class="menuButtonDecor"
                  mat-menu-item
                  (click)="changePassword()"
                  (keyup.enter)="changePassword()"
                  tabindex="0"
                >
                  Change Password
                </button>
              }
              <button class="menuButtonDecor" mat-menu-item (click)="logout()" (keyup.enter)="logout()" tabindex="0">
                Logout
              </button>
            </mat-menu>
          </span>
        </li>
      </ul>
    }
  </div>
</header>
@if (!hideTabs) {
  <div class="d-flex justify-content-between tabDivStyle">
    <div class="headerTab">
      <div class="d-flex">
        <div class="DSA_wb_customTab DSA_navTabWhite DSA_wb_Secondary marL32 widthLateralTabs marT4 nopadL">
          @if (!showMaintenance) {
            <mat-tab-group
              disableRipple
              #tabGroup
              (selectedTabChange)="tabChanged($event.index)"
              [(selectedIndex)]="selectedTabIndex"
            >
              @for (tab of tablists; track tab) {
                <mat-tab #tab>
                  <ng-template mat-tab-label>
                    <span class="tab-label">{{ tab.feature }}</span>
                  </ng-template>
                </mat-tab>
              }
            </mat-tab-group>
          }
        </div>
      </div>
    </div>
    <button mat-icon-button class="burgerbtn" [matMenuTriggerFor]="menu">
      <mat-icon class="burger">{{ isMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @if (helpLinks.length > 0) {
        <button mat-menu-item class="menuBtn" [matMenuTriggerFor]="menuHP">Helplinks</button>
      }
      <mat-menu #menuHP="matMenu">
        @for (link of helpLinks; track link) {
          <div>
            <a
              class="text-underline"
              mat-menu-item
              class="menuOptn"
              matTooltip="{{ link?.description }}"
              matTooltipClass="DSA_tooltip"
              matTooltipPosition="above"
              (click)="downloadFile(link?.url, link?.name)"
              (keyup.enter)="downloadFile(link?.url, link?.name)"
              tabindex="0"
              >{{ link?.name }}
            </a>
          </div>
        }
      </mat-menu>
      @for (link of links; track link) {
        <a mat-menu-item href="{{ link.value }}" target="_blank" class="anchorDesign marT8">{{ link.label }}</a>
      }
    </mat-menu>
    <div class="menuDesk">
      @if (helpLinks.length > 0) {
        <button class="menuBtn" mat-button [matMenuTriggerFor]="menuDT">
          <mat-icon>arrow_drop_down</mat-icon>Helplinks
        </button>
      }
      <mat-menu #menuDT="matMenu">
        @if (helpLinks) {
          <div>
            @for (link of helpLinks; track link) {
              <div>
                @if (link?.url.includes('infyme.infosysapps.com')) {
                  <a
                    class="text-underline"
                    mat-menu-item
                    class="anchorDesign"
                    target="_blank"
                    matTooltip="{{ link?.description }}"
                    matTooltipClass="DSA_tooltip"
                    matTooltipPosition="above"
                    href="{{ link?.url }}"
                    >{{ link?.name }}
                  </a>
                }
                @if (!link?.url.includes('infyme.infosysapps.com')) {
                  <a
                    class="text-underline"
                    mat-menu-item
                    class="menuOptn"
                    matTooltip="{{ link?.description }}"
                    matTooltipClass="DSA_tooltip"
                    matTooltipPosition="above"
                    (click)="downloadFile(link?.url, link?.name)"
                    (keyup.enter)="downloadFile(link?.url, link?.name)"
                    tabindex="0"
                    >{{ link?.name }}
                  </a>
                }
              </div>
            }
          </div>
        }
      </mat-menu>
      @for (link of links; track link) {
        <span class="marT8 flexWidth">
          <a href="{{ link.value }}" target="_blank" class="anchorDesign">{{ link.label }}</a>
        </span>
      }
    </div>
  </div>
}
@if (showMaintenance) {
  <app-maintenance />
}
